import { X } from 'react-feather'
import { Modal, ModalBody } from 'reactstrap'
import FormAddFisheries from '../forms'

const ModalEdit = ({
  row,
  isOpenModalEdit,
  onHandleOpenCloseModalEdit,
  handleRefetch,
}) => {
  return (
    <Modal
      centered
      isOpen={isOpenModalEdit}
      toggle={() => onHandleOpenCloseModalEdit()}
      data-testid="fishery-modal-edit"
    >
      <ModalBody>
        <div className="d-flex justify-content-between align-item-center">
          <h6>Ubah Data Fishery</h6>
          <X
            style={{ cursor: 'pointer' }}
            onClick={() => onHandleOpenCloseModalEdit()}
            data-testid="fishery-modal-edit-close-button"
          />
        </div>
        <FormAddFisheries
          row={row}
          onHandleOpenCloseModalEdit={onHandleOpenCloseModalEdit}
          handleRefetch={handleRefetch}
        />
      </ModalBody>
    </Modal>
  )
}

export default ModalEdit
